import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
const highlights = ['Theory + 50 Jazz Exercises', '6 Complete Volumes', '6 Free Bonus Gifts', 'Complete Theory Section', '100% PDF · Print & Teach'];
const assurances = [{
  icon: LockIcon,
  label: 'Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: ShieldCheckIcon,
  label: '10-Day Guarantee'
}];
export function Hero() {
  return <header id="top" className="bg-night" data-id="element-181" data-mp="x8b7dnrar92u">
      <div className="mx-auto max-w-shell px-5 pb-12 pt-12 sm:px-6 sm:pb-16 sm:pt-16" data-id="element-182" data-mp="sarsclmrys9u">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-4xl text-center" data-id="element-183" data-mp="ncgiwc0e6js5">
          <Eyebrow align="center" data-id="element-184" data-mp="381nv9anuav4h">The complete method for jazz guitar teachers</Eyebrow>

          <h1 className="mt-6 font-display text-[2.6rem] leading-[0.95] sm:text-7xl lg:text-8xl" data-id="element-185" data-mp="3j9k9f79139e0">
            <span className="block text-cream" data-id="element-186" data-mp="3o6kfvj9sie5n">Sort out your entire</span>
            <span className="block text-amber" data-id="element-187" data-mp="39al8kaui8i1k">jazz term with this pack</span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl font-serif text-lg italic leading-relaxed text-cream-soft sm:text-2xl" data-id="element-188" data-mp="3e960lmzlrvex">
            The &ldquo;Print &amp; Go&rdquo; system for jazz guitar teachers that turns your lesson
            planning from <span className="text-amber" data-id="element-189" data-mp="359syxghq0b4r">chaotic</span> into{' '}
            <span className="text-cream" data-id="element-190" data-mp="2qk3kijkmaamj">obvious</span>.
          </p>
        </motion.div>

        <div className="relative mx-auto mt-10 max-w-5xl sm:mt-12" data-id="element-191" data-mp="2viy25i6ult52">
          <span className="absolute -top-3.5 right-4 z-10 rounded-full bg-amber px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-night sm:-top-4 sm:right-6 sm:px-4 sm:text-xs" data-id="element-192" data-mp="2vj7uhcfd8cdx">
            6 Volumes + 6 Bonuses
          </span>
          <div className="rounded-2xl border border-night-600 bg-night-800 p-2 sm:p-3" data-id="element-193" data-mp="s2jnhxye22k1">
            <img src="https://cdn.magicpatterns.com/uploads/vFchDyybp1gA7zUWkdrNdP/ChatGPT_Image_25_ago_2026,_12_38_39_p.m..png" alt="The complete Jazz Teacher's Arsenal: six workbooks, the course on desktop, tablet and phone" className="w-full rounded-xl" data-id="element-194" data-mp="nbl58stuaue5" />
          </div>
        </div>

        <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap justify-center gap-x-5 gap-y-2 sm:gap-x-7" data-id="element-195" data-mp="1azkvlrn8ois7">
          {highlights.map(item => <li key={item} className="text-[10px] font-semibold uppercase tracking-label text-cream-muted sm:text-[11px]" data-id="element-196" data-mp="112pwp7n20gde">
              {item}
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col items-center gap-3" data-id="element-197" data-mp="3lt774vhctzwd">
          <CtaButton size="lg" target="offer" data-id="element-198" data-mp="3lqm4435bldx1">
            Get the Arsenal now
          </CtaButton>
          <p className="text-xs text-amber-light" data-id="element-199" data-mp="3htpwlnn2mckc">
            $27 today &mdash; the price returns to $97 when the timer runs out.
          </p>
          <div className="mt-2 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-200" data-mp="21bxy9551wsbc">
            {assurances.map(({
            icon: Icon,
            label
          }) => <span key={label} className="flex items-center gap-2 text-xs text-cream-muted" data-id="element-201" data-mp="267wkam2wpy8l">
                <Icon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-202" data-mp="2b2smug5rs3zy" />
                {label}
              </span>)}
          </div>
        </div>
      </div>
    </header>;
}